import { ContentColor } from '../typography/contentColor';
import H6 from '../typography/Heading/H6/H6';
import { DisabledDiv, TextWrapper } from './icons.styled';

interface IconProps {
	disabled?: boolean;
	fontSize?: number;
	hoverColor?: string;
	onClick?: () => void;
	selected?: boolean;
	title: string;
	titleH?: boolean;
}

const CloseIcon = ({ onClick, title, selected, fontSize, hoverColor, disabled }: IconProps) => {
	return (
		<DisabledDiv disabled={disabled}>
			<TextWrapper fontSize={fontSize} hoverColor={hoverColor} onClick={onClick} selected={selected}>
				<H6 contentColor={selected ? ContentColor.WHITE : ContentColor.DARK}>{title}</H6>
			</TextWrapper>
		</DisabledDiv>
	);
};

export default CloseIcon;
